<template>
  <v-alert class="document-versioning-duplicate-box" style="background-image: url('@/assets/img/m365-background.png')"
            closable
  >
    <p class="text--medium text--bold">{{ $t(`${TRANSLATION_KEY_PREFIX}.title`) }} ⚡</p>
    <p class="mt-3 text--small">{{ $t(`${TRANSLATION_KEY_PREFIX}.text`) }}</p>
    <v-checkbox v-model="hideBox"
                :label="$t(`${TRANSLATION_KEY_PREFIX}.checkboxLabel`)"
                hide-details
                @update:model-value="onHideBoxChange"
    ></v-checkbox>
  </v-alert>
</template>

<script>
const TRANSLATION_KEY_PREFIX = 'common.document-versioning.DocumentVersioningWopiDuplicationBox'

export default {
  name: 'DocumentVersioningWopiDuplicationBox',
  emits: ['hide'],
  data () {
    return {
      TRANSLATION_KEY_PREFIX,
      hideBox: false,
    }
  },
  methods: {
    onHideBoxChange (value) {
      this.$emit('hide', value)
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.document-versioning-duplicate-box {
  background-size: cover;
  background-position: center right;
  border: get-border();
  @include border-radius('border-radius-4');
  margin-bottom: 0;
  padding: 16px;
  }

:deep(.v-alert__dismissible) {
  margin: -4px -4px auto 0;

  i.v-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
  }
}
</style>
